import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "@/lib/seo";

export const Breadcrumbs = ({ items, className = "" }) => (
  <nav aria-label="Breadcrumb" className={`text-xs sm:text-sm text-[#8D6E63] ${className}`} data-testid="breadcrumbs">
    <ol className="flex items-center flex-wrap gap-1.5">
      {items.map((it, i) => (
        <li key={it.label} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-[#8D6E63]/70" />}
          {it.to ? (
            <Link to={it.to} className="hover:text-[#2E7D32] transition-colors">{it.label}</Link>
          ) : (
            <span className="text-[#143C18] font-semibold" aria-current="page">{it.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export const breadcrumbJsonLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    ...(it.to ? { item: `${SITE_URL}${it.to === "/" ? "/" : it.to}` } : {}),
  })),
});
